import { Component, OnInit, EventEmitter, Inject, Input } from '@angular/core';
import { IModule } from 'projects/web-user-profile/src/app/models/templates/modules/i-module';
import { ReportProfileBaseModel, UserModel, BaseProviderInstanceResourceModel, MicrosoftOfficeReportProfileModel, OneDriveReportProfileDelegate, OneDriveReportProfile, AlertInvalidStateFeaturedModel, SharePointReportProfilePermissions, ReportProfileResourceBase } from '@i2a/web-api-client';
import { RegisterMyProfileComponent } from 'projects/web-user-profile/src/app/decorators/my-profile-component.decorator';
import { ProfileBaseClassComponent } from '../../../../shared/profile-base-class-component';
import { ToastrService } from 'ngx-toastr';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ProfileHelper } from 'projects/web-user-profile/src/app/helpers/profile-helper';
import { OneDriveDelegateConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/one-drive-delegate-configuration';
import { TemplateConstants } from 'projects/web-user-profile/src/app/models/templates/template-constants';
import dayJS from 'dayjs';
import { BaseTemplate } from 'projects/web-user-profile/src/app/models/templates/base-template';
import { OneDriveDelegate } from 'projects/web-user-profile/src/app/models/providers/microsoft/one-drive/one-drive-delegate';
import { OneDriveDelegates } from 'projects/web-user-profile/src/app/models/providers/microsoft/one-drive/one-drive-delegates';

@RegisterMyProfileComponent(TemplateConstants.MODULE_ONEDRIVE_DELEGATE)
@Component({
  selector: 'i2a-one-drive-delegate-module',
  templateUrl: './one-drive-delegate-module.component.html',
  styleUrls: ['./one-drive-delegate-module.component.scss']
})
export class OneDriveDelegateModuleComponent extends ProfileBaseClassComponent<OneDriveDelegateConfiguration,OneDriveReportProfile> implements OnInit, IModule<OneDriveDelegateConfiguration> {
  private resource: BaseProviderInstanceResourceModel;

  public delegates: OneDriveDelegate[] = [];
  public externalDelegates: OneDriveDelegate[] = [];

  public showMore: boolean;
  public showMoreAfter: number;
  public maxShowMore: number;
  public isVisibleButtonsShowMore: boolean;
  private isActiveShowMoreOption: boolean;

  constructor(
    toastr: ToastrService,
    @Inject(I18NEXT_SERVICE) i18Next: ITranslationService) {
    super(toastr, i18Next, null);
  }

  ngOnInit() {
  }

  initialize(user: UserModel, profile: ReportProfileBaseModel, configuration: OneDriveDelegateConfiguration, alerts: AlertInvalidStateFeaturedModel[], resource: BaseProviderInstanceResourceModel, resourceTemplate?: BaseTemplate): void {
    this.baseInitialize(user, profile, configuration, alerts);
    this.resource = resource;
    this.resourceProfile = (<MicrosoftOfficeReportProfileModel>profile).oneDriveProfiles.find(r => r.providerInstanceResource.providerInstanceResourceId == resource.providerInstanceResourceId);
    var delegates = OneDriveDelegateModuleComponent.SetDelegates(this.resourceProfile.delegates, this.resourceProfile.permissions, this.configuration, this.i18Next);
    delegates?.delegates?.forEach((d: OneDriveDelegate) => {
      if (d.permissions?.isAnonymousUser || d.permissions?.isTheWholeCompany) {
        this.delegates.unshift(d);
      } else {
        this.delegates.push(d);
      }
    }); 
    this.externalDelegates = delegates.externalDelegates;

    this.showMoreAfter = configuration.showMoreAfter ?? 0;
    this.isActiveShowMoreOption = this.showMoreAfter > 0;
    this.isVisibleButtonsShowMore = this.isActiveShowMoreOption && (this.delegates?.length + (this.externalDelegates?.length > 0 ? 1 : 0)) > this.showMoreAfter;
    this.setShowMoreValue();
  }

  public static SetDelegates(oneDriveProfileDelegates: OneDriveReportProfileDelegate[], sharePointProfilePermissions: SharePointReportProfilePermissions[], configuration: OneDriveDelegateConfiguration, i18Next: ITranslationService): OneDriveDelegates {
    var delegates: OneDriveDelegate[] = [];
    var externalDelegates: OneDriveDelegate[] = [];

    if (oneDriveProfileDelegates) {
      var alldelegates = OneDriveDelegateModuleComponent.JoinDelegateAndPermissions(configuration.displayOnlyAccesses, oneDriveProfileDelegates, sharePointProfilePermissions);

      //TODO uncomment hasInstantMessagingShare if we want to filter delegates with hasInstantMessagingShare
      delegates = alldelegates.filter(d => d.accesses.foldersAccessed.length > 0 && !d.accesses.isAnonymousUser && // !d.accesses.hasInstantMessagingShare &&
        ((d.accesses.isExternalUser && !configuration.groupExternalDelegates) || !d.accesses.isExternalUser));
      let anonymousUsers = alldelegates.filter(d => d.accesses.foldersAccessed.length > 0 && d.accesses.isAnonymousUser );//&& !d.accesses.hasInstantMessagingShare);
      OneDriveDelegateModuleComponent.ProcessDelegates(anonymousUsers, delegates);
      if (configuration.groupExternalDelegates) {
        externalDelegates = alldelegates.filter(d => d.accesses.foldersAccessed.length > 0 && d.accesses.isExternalUser );//&& !d.accesses.hasInstantMessagingShare);
        externalDelegates.sort((a, b) => { return ProfileHelper.compare(a.accesses, b.accesses, i18Next); });
      }
      if (externalDelegates.length < configuration.groupExternalDelegatesAt) {
        externalDelegates.forEach(d => {
          delegates.push(d);
        });
        externalDelegates = [];
      }
      delegates.sort((a, b) => { return ProfileHelper.compare(a.accesses, b.accesses, i18Next); });
    }
    return {
      delegates: delegates,
      externalDelegates: externalDelegates
    }
  }

  public static JoinDelegateAndPermissions(displayOnlyAccesses: boolean, oneDriveProfileDelegates: OneDriveReportProfileDelegate[], sharePointProfilePermissions: SharePointReportProfilePermissions[]): OneDriveDelegate[] {
    return oneDriveProfileDelegates.map(delegate => {
      var result = { accesses: delegate, permissions: null };
      if (!displayOnlyAccesses) {
        var idx = -1;
        if (delegate.userId != null) {
          idx = sharePointProfilePermissions.findIndex(d => d.userId != null && d.userId == delegate.userId);
        }
        else if (delegate.providerInstanceUser != null) {
          idx = sharePointProfilePermissions.findIndex(d => d.providerInstanceUser != null && d.providerInstanceUser.providerInstanceResourceId == delegate.providerInstanceUser.providerInstanceResourceId);
        }
        else {
          idx = sharePointProfilePermissions.findIndex(p => p.logonUserId == delegate.logonUserId);
        }
        if (idx >= 0) {
          result.permissions = sharePointProfilePermissions[idx];
        }
      }
      return result;
    });
  }

  private static ProcessDelegates(delegateToAdd: OneDriveDelegate[], dest: OneDriveDelegate[]) {
    if (delegateToAdd.length > 0) {
      let delegate = delegateToAdd.shift();
      delegateToAdd.forEach(user => {
        user.accesses.foldersAccessed.forEach(f => {
          if (delegate.accesses.foldersAccessed.indexOf(f) == -1) {
            delegate.accesses.foldersAccessed.push(f);
          }
          if (dayJS(user.accesses.lastAccess).isAfter(dayJS(delegate.accesses.lastAccess))) {
            delegate.accesses.lastAccess = user.accesses.lastAccess;
          }
        })
      });
      delegate.accesses.foldersAccessed.sort();
      dest.push(delegate);
    }
  }

  public onShowMore() {
    this.showMore = !this.showMore;
    this.setShowMoreValue();
  }

  private setShowMoreValue() {
    this.maxShowMore = (!this.showMore && this.isActiveShowMoreOption) ? (this.showMoreAfter - (this.externalDelegates?.length > 0 ? 1 : 0)) : this.delegates?.length;
  }

  alertSent(event): void {
    this.onAlertSent.emit(event);
  }
}
